module.exports = __webpack_public_path__ + "img/62-Teck de Brunéo AnTEAK.jpg";